let searchTimeout;
let currentQuery = '';

const searchInput = document.querySelector('.jss-input');
const resultsEl = document.querySelector('.jss-results');
const emptyResultsHtml = resultsEl ? resultsEl.innerHTML : '';

function closeNav() {
  document.body.classList.remove('naved', 'nav-int');
  document.querySelectorAll('.left-sub.active').forEach(function (el) {
    el.classList.remove('active');
  });
  document.querySelectorAll('.main-nav-wrap a.line.active').forEach(function (el) {
    el.classList.remove('active');
  });
}

function openSearchUi() {
  closeNav();
  document.querySelector('html').classList.add('js-search-loaded');
}

function closeSearch() {
  document.querySelector('html').classList.remove('js-search-loaded');
  if (searchInput) {
    searchInput.value = '';
  }
  if (resultsEl && emptyResultsHtml) {
    resultsEl.innerHTML = emptyResultsHtml;
  }
  const searchContainer = document.querySelector('.js-search');
  if (searchContainer) {
    searchContainer.setAttribute('data-search-type', 'product');
  }
}

if (searchInput) {
  searchInput.addEventListener('click', function () {
    openSearchUi();
  });

  searchInput.addEventListener('focus', function () {
    openSearchUi();
  });

  searchInput.addEventListener('input', function () {
    clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      const query = this.value.trim();
      if (query.length > 0) {
        loadSearchSection(query);
      } else if (resultsEl && emptyResultsHtml) {
        resultsEl.innerHTML = emptyResultsHtml;
      }
    }, 300);
  });
}

function openSearchFromPrompt() {
  openSearchUi();
  if (searchInput) {
    searchInput.focus();
  }
}

const jssmpWraps = document.querySelectorAll('.jssmp-wrap');
jssmpWraps.forEach(function (jssmpWrap) {
  jssmpWrap.addEventListener('click', function () {
    openSearchFromPrompt();
  });
  jssmpWrap.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      openSearchFromPrompt();
    }
  });
});

function loadSearchSection(query) {
  openSearchUi();

  const searchContainer = document.querySelector('.js-search');
  const stype = searchContainer && searchContainer.getAttribute('data-search-type') === 'article'
    ? 'article'
    : 'product';

  currentQuery = query.trim();
  if (!currentQuery) return;

  fetch(
    `/search/suggest?q=${encodeURIComponent(currentQuery)}&resources[type]=${stype},query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=zpro-search`
  )
    .then((response) => response.text())
    .then((data) => {
      if (resultsEl) {
        resultsEl.innerHTML = data;
      }
    })
    .catch((error) => console.error('Error loading search section:', error));
}

document.addEventListener('click', function (e) {
  const swapEl = e.target.closest('[data-swap-search]');
  if (swapEl) {
    const searchType = swapEl.getAttribute('data-swap-search');
    const searchContainer = document.querySelector('.js-search');
    if (searchContainer) {
      searchContainer.setAttribute('data-search-type', searchType);
    }
    e.preventDefault();
    if (currentQuery) {
      loadSearchSection(currentQuery);
    }
  }
});

document.addEventListener('click', function (e) {
  const closeSearchBtn = e.target.closest('.close-search');
  const openSearchBtn = e.target.closest('.openSearch');
  const jsSearchElement = e.target.closest('.js-search');
  const menuOpenBtn = e.target.closest('.mob-burger, .main-nav-wrap > a.line');

  if (closeSearchBtn) {
    closeSearch();
    e.preventDefault();
  }

  if (openSearchBtn) {
    openSearchUi();
    if (searchInput) {
      setTimeout(function () {
        searchInput.focus();
      }, 10);
    }
    e.preventDefault();
  }

  // Opening the menu / nav closes search
  if (menuOpenBtn && document.documentElement.classList.contains('js-search-loaded')) {
    closeSearch();
  }

  if (jsSearchElement && !e.target.closest('.jss-input') && !e.target.closest('.jss-results') && !e.target.closest('.jss-form-wrap')) {
    closeSearch();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    closeSearch();
  }
});
